import React, { useEffect } from "react";
import ReachNewMarkets from "web/assets/images/reach-new-markets.png";
import MarketingCampaign from "web/assets/images/marketing-campaign.png";
import PrivateGroups from "web/assets/images/private-groups.png";
import CorporatePartners from "web/assets/images/corporate-partners.png";
import IdentifyTrends from "web/assets/images/identify-trends.png";
import SecurePayments from "web/assets/images/secure-payments.png";
import TransactionVisibility from "web/assets/images/transaction-visibility.png";
import MobileDesktop from "web/assets/images/mobile-desktop.png";
import AOS from "aos";
import { useHistory } from 'react-router-dom';

import {
  Container,
  Wrapper,
  GroupSection,
  BoxSection,
} from "web/pages/public/landing-page/WhoItFor/PalletSellers/PalletSellersStyled";
const Data = [
  {
    id: 1,
    heading: "Reach New Markets",
    subHeading:
      "Sell components or pallets to local, regional, and national depots or pallet users who were previously unreachable.",
    src: `${ReachNewMarkets}`,
  },
  {
    id: 2,
    heading: "Marketing Campaign",
    subHeading:
      "PalletTrader will be supported by an aggressive marketing campaign, driving traffic to the site and your pallet offerings.",
    src: `${MarketingCampaign}`,
  },
  {
    id: 4,
    heading: "Private Groups",
    subHeading:
      "PalletTrader enables private transactions. Post your pallets to the marketplace, or to one of your private groups.",
    src: `${PrivateGroups}`,
  },
  {
    id: 5,
    heading: "Build New Partnerships",
    subHeading:
      "Sellers can identify new sales opportunities, while eliminating the inefficiency of travel, discovery, and recruitment.",
    src: `${CorporatePartners}`,
  },
  {
    id: 6,
    heading: "Identify Market Trends",
    subHeading:
      "PalletTrader provides market intelligence. Know where the market is at, and where it’s going. You’ll buy and sell smarter.",
    src: `${IdentifyTrends}`,
  },
  {
    id: 8,
    heading: "Secure Payments",
    subHeading:
      "PalletTrader provides secured payment methods, with activity reporting. Quickly convert cold calls into qualified transactions.",
    src: `${SecurePayments}`,
  },
  {
    id: 9,
    heading: "Transaction Visibility",
    subHeading:
      "From the time a bid or offer has been accepted until pick-up or delivery, buyers and sellers have complete transaction visibility. ",
    src: `${TransactionVisibility}`,
  },
  {
    id: 10,
    heading: "At The Office Or On The Go",
    subHeading:
      "Transform your pallet supply management with the power of e-commerce. Buy or Sell from any device.",
    src: `${MobileDesktop}`,
  },
];

const PalletSellers = () => {
  let history = useHistory();
  const signUp = () => {
    history.push('/registration')
    
  }
  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);
  return (
    <Container data-aos="fade-up" data-aos-delay="400">
      <Wrapper>
        <h4 className="blue-text">Pallet Sellers.</h4>
        <h4>Power your sales. Empower your team.</h4>
        <h5>
          If you have pallets to sell, PalletTrader is the ultimate tool for the
          job. You decide how many lots are available, name your price, or make
          it a sale to the highest offer. You’ll have the option to show your
          desired price, and to sell all lots to one buyer, or sell to many
          buyers. However you choose to go to market, PalletTrader puts you in
          control.
        </h5>
        <GroupSection>
          {Data.map((e) => {
            return (
              <BoxSection key={e.id}>
                <img src={e.src} alt="NounPins" />
                <h6>{e.heading}</h6>
                <p>{e.subHeading}</p>
              </BoxSection>
            );
          })}
        </GroupSection>
        <button onClick={signUp}>Sign Me Up</button>
      </Wrapper>
    </Container>
  );
};

export default PalletSellers;
